import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from '../base/api.service';

@Injectable({
  providedIn: 'root',
})
export class IndividualSearchService extends ApiService {
  searchByName(request: any): Observable<any> {
    return this.post(`/platform/api/individual-search/searchByName`, request);
  }

  searchById(request: any): Observable<any> {
    return this.post(`/platform/api/individual-search`, request);
  }

  lastSearches(): Observable<any> {
    return this.post(`/platform/api/individual-search/lastSearches`);
  }
}
